import { render, staticRenderFns } from "./FavouriteMarkets.vue?vue&type=template&id=8e6ed1fa"
import script from "./FavouriteMarkets.vue?vue&type=script&lang=js"
export * from "./FavouriteMarkets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports